export type PersonaCoverLifecycle = {
  coverRegenerationStatus?: string | null;
};

export function isPersonaCoverRegenerating(
  persona: PersonaCoverLifecycle | null | undefined,
): boolean {
  return persona?.coverRegenerationStatus === "generating";
}

export function isPersonaCoverRegenerated(
  persona: PersonaCoverLifecycle | null | undefined,
): boolean {
  return persona?.coverRegenerationStatus === "ready";
}

export function resolvePersonaImageAfterPrimaryCharacterEnrichment(
  personaImageUrl: string | null | undefined,
  primaryCharacterAvatarUrl: string | null | undefined,
  coverRegenerationStatus: string | null | undefined,
): string | null {
  if (coverRegenerationStatus === "generating" || coverRegenerationStatus === "ready") {
    return personaImageUrl ?? null;
  }
  return primaryCharacterAvatarUrl ?? personaImageUrl ?? null;
}

export function resolvePersonaCardBandImage(persona: {
  imageUrl?: string | null;
  heroImageUrl?: string | null;
  coverRegenerationStatus?: string | null;
}): string | null {
  if (isPersonaCoverRegenerating(persona)) return null;
  if (isPersonaCoverRegenerated(persona)) return persona.imageUrl ?? null;
  return persona.heroImageUrl ?? persona.imageUrl ?? null;
}